import { Crown, Sparkles, Handshake } from "lucide-react";

const PILLARS = [
  {
    icon: Crown,
    title: "Culture",
    body: "Built for Black professionals, entrepreneurs, and families who lead with presence. Art that mirrors the room you walk into.",
  },
  {
    icon: Sparkles,
    title: "Legacy",
    body: "Every Crowned Canvas piece is made to outlive the moment — heirloom craft, not content. The kind of art your grandchildren inherit.",
  },
  {
    icon: Handshake,
    title: "Luxury",
    body: "Museum-grade materials, hand-tuned artistry, and white-glove delivery. Quiet luxury — never loud, never lacking.",
  },
];

export default function Legacy() {
  return (
    <section
      id="legacy"
      data-testid="legacy-section"
      className="relative z-10 border-t border-white/5 py-24 md:py-32"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <p className="overline">More Than Art</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.02]">
              A culture.<br />
              A legacy.<br />
              <span className="italic text-[#D4AF37]">A luxury brand.</span>
            </h2>
          </div>
          <p className="md:col-span-6 md:col-start-7 text-white/65 font-light leading-relaxed text-base md:text-lg self-end">
            Crowned Canvas Creations is built for Black professionals,
            creators, and entrepreneurs who understand that taste is
            inheritance. We don't just print photos — we build pieces that
            anchor a room, a brand, and a generation.
          </p>
        </div>

        {/* Pillars */}
        <div className="grid md:grid-cols-3 border-y border-white/10">
          {PILLARS.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`legacy-pillar-${p.title.toLowerCase()}`}
                className="group p-8 md:p-10 border-b md:border-b-0 md:border-r border-white/10 last:border-r-0 hover:bg-white/[0.02] transition-colors"
              >
                <Icon
                  className="w-6 h-6 text-[#D4AF37] group-hover:scale-110 transition-transform"
                  strokeWidth={1.5}
                />
                <h3 className="font-serif-display text-2xl mt-6">{p.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed mt-3 font-light">
                  {p.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
